import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment, useRef} from 'react';
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, MenuItem, Avatar, Box, Hidden,Button, Grid,Tabs,Tab} from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import TextField from '@mui/material/TextField';
import { useMessage } from "../../context/message-context";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import MessageBox from "../shared/components/MessageBox";
function ToDosGlobal(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [aufgaben, setAufgaben] = useState([]);
  const { accessToken,  client} = props;
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState(localStorage.getItem("HAUFST_FILTER") ? localStorage.getItem("HAUFST_FILTER") : "OHA" );
  const [textfilter, setTextFilter] = useState("");
  const [dialog,setDialog] = useState(false);
  const [zeile,setZeile] = useState([]);
  const auswahl = useRef([]);
  const [msgboxloeschen,setMsgBoxLoeschen] = useState(false);
  const [msgboxerledigen,setMsgBoxErledigen] = useState(false);
  
  const neue_aufgabe = () => {
    navigate("/WEBAGU/add")
  }
  const {hideMessage, showErrorMessage} = useMessage();
  const [details,setDetails] = useState(false); 
  const aufgabe_erledigen = (aufgabenkey) => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "WEBAGG",
      "statement": "AUFGABE_ERLEDIGEN",
      "aufgabe":aufgabenkey,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, aufgabenCb);  
  }
  const ladeDocuments = () => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "WEBAGG",
      "statement": "HOLE_AUFGABEN",
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, aufgabenCb);
  }
  const filter_aendern = (filter,typ) => {
    if (typ==="art") {
      localStorage.setItem("HAUFST_FILTER",filter)
      setFilter(filter);
    }
    if (typ==="text") {
      setTextFilter(filter)
    }
  }
  const hdok_aufgabe = (aktion) => {
    setDialog(false);
    if (aktion==="verschicken") { 
      navigate("/LTERW2/?hvktKey=" + zeile);
    }
    if (aktion==="erledigen") {
      aufgabe_erledigen(zeile);
    }
  }
  const details_anzeigen = (element) => {
    auswahl.current=element
    setDetails(true);
  }
  const aktionen = (element,aktion) =>  {
    setDetails(false);
    if (aktion==="bestätigen") {
      setZeile(element.key);
      if (element.hdok) {
        setDialog(true)
      } else if (element.aktion === "HDBD") {
        navigate("/WEBPDB/pflichtdoc/confirm/"+element.aktion_key.slice(0,4));
      } else if (element.aktion === "WURG") {
        navigate("/PMURA3/antragsdetails/V"+element.aktion_key);
      } else if (element.aktion === "XXXX") {
        navigate("/WEBAGU/dynamisch/"+element.key);
      } else if (!element.aktion) {
        setMsgBoxErledigen(true)
      }
    }
    if (aktion==="löschen") {
      
    }
    
  }
  
  useEffect(() => {
    ladeDocuments()
    // eslint-disable-next-line
  }, [])
  
const aufgabenCb = (response) => {
  setIsLoading(false);
  if (response.status === 200) {
      if (response.data.Liste) {
          setAufgaben(response.data.Liste);
      } else {
          setAufgaben([]);
      }
      hideMessage();
  } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
  }      
}
const errorCb = () => {
  setIsLoading(false);
  showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
}
const loeschen = () => {
  setIsLoading(true);
  const payload={
    "mandant": client,
    "program": "WEBAGG",
    "statement": "AUFGABE_LOESCHEN",
    "aufgabe":auswahl.current.Key
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'daten', payload, headers, aufgabenCb, errorCb);
}
const messageBoxErledigenResult = (result) => {  
  if (result === 'YES') {
    aufgabe_erledigen(auswahl.current.Key);
  }
  setMsgBoxErledigen(false)
}
if (msgboxerledigen) {
  return(
    <MessageBox 
      open={msgboxerledigen}
      handleResponse={messageBoxErledigenResult}
      buttons="YESNO"
      text={'Sind Sie sich sicher, dass Sie die Aufgabe "' + auswahl.current.Bezeichnung  + '" zum heutigen Datum erledigen wollen?"'}
      title={t("Löschbestätigung")}
      onClose={() => setMsgBoxErledigen(false)}
    />
  )  
}
const messageBoxLoeschenResult = (result) => {  
  if (result === 'YES') {
    loeschen();
  }
  setMsgBoxLoeschen(false)
}
if (msgboxloeschen) {
  return(
    <MessageBox 
      open={msgboxloeschen}
      handleResponse={messageBoxLoeschenResult}
      buttons="YESNO"
      text={'Soll die Aufgabe "' + auswahl.current.Bezeichnung + '" wirklich gelöscht werden?"'}
      title={t("Löschbestätigung")}
      onClose={() => setMsgBoxLoeschen(false)}
    />
  )  
}
  if (isLoading) {
    return (
      <Layout>
        <LoadingComponent />
      </Layout>
    )
  }
  const filterByType = (element) => {
    var result;
    var prueftext=element.Bezeichnung + " " + element.Inhaber 
    switch (filter) {
      case "O":
          result = element.Kategorie==="Offen";
        break;
      case "E":
          result = element.Kategorie==="Erledigt";
        break;
      case "A":
          result = element.Kategorie==="Erledigt" || element.Kategorie==="Offen";
        break;
      case "OHA":
          result = element.Kategorie==="Offen ohne App"; 
        break;
      default:
        result = false;
        break;
    }
    if (textfilter && result) {result= prueftext.toLowerCase().includes(textfilter.toLowerCase()) }
    
    return(result);
  }
   
  const dataRequest = (aufgaben.filter(element => filterByType(element)).length>0) ? aufgaben.filter(element => filterByType(element)).map((element) => {
    return (
        <TableRow style={{cursor: 'pointer'}} onClick={() => details_anzeigen(element)}  >
        <TableCell></TableCell>
        <TableCell><Typography >{element.Bezeichnung}</Typography></TableCell>
        <TableCell><Typography >{element.Inhaber}</Typography></TableCell> 
        </TableRow>        
      );
    }
  )
  :
    <TableRow  >
      <Hidden smDown>          
        <TableCell colSpan="4">
          <Typography variant="body1">{t("Es wurden keine Aufgaben gefunden")}</Typography>
        </TableCell>
      </Hidden>
      <Hidden smUp>
        <TableCell colSpan="3">
          <Typography variant="body1">{t("Es wurden keine Aufgaben gefunden")}</Typography>
        </TableCell>          
      </Hidden>
     </TableRow>
  ;
  const tabellen_head = () => {
      return(
        <Fragment>
          <TableCell></TableCell>
          <TableCell>{t("Bezeichnung")}</TableCell>
          <TableCell>{t("Inhaber")}</TableCell>
        </Fragment>
      )     
  }
  return (
    <Page >
      <Layout>
        <Box pt={1} pb={1}>
          <Button fullWidth variant="contained" color="primary" onClick={()=>neue_aufgabe()}>{t("Neue Aufgabe")}</Button>
        </Box>
      <Grid container justifyContent="center">
        <Grid item xs={12}> 
         <Grid container justifyContent="center" spacing={2} >
           <Grid item xs={12}>
      <TextField
        select
        variant="outlined"
        label={t("Filter")}
        value={filter}
        onChange={(event) => filter_aendern(event.target.value,"art")}
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
      >
        <MenuItem value="OHA">{t("offene Aufgaben ohne App")}</MenuItem>
        <MenuItem value="O">{t("offene Aufgaben")}</MenuItem>
        <MenuItem value="E">{t("erledigte Aufgaben")}</MenuItem>
        <MenuItem value="A">{t("Alle Aufgaben")}</MenuItem>
      </TextField>
     </Grid>
     <Grid item xs={12}>
      <TextField
        variant="outlined"
        label={t("Textfilter")}
        value={textfilter}
        onChange={(event) => filter_aendern(event.target.value,"text")}
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
      >
      </TextField>
      </Grid>
      </Grid>
      </Grid>
      </Grid>
        <TableContainer>
          <Table> 
            <TableHead>
              <TableRow>
                { tabellen_head() }
              </TableRow>
            </TableHead>           
            <TableBody>
              { dataRequest }        
            </TableBody> 
          </Table>
          </TableContainer>    
      <ResponsiveDialog 
          title={t("Soll eine Datei verschickt werden?")}
          open={dialog}
          setOpen={(o) => {setDialog(false)}}
       >
       <Box p={1}> 
       <Grid container justifyContent="center">
          <Grid item xs={12}> 
          <Grid container justifyContent="center" spacing={2} >
              <Grid item xs={12} sm={6} >
                <Button variant="contained" color="primary" fullWidth  onClick={() => hdok_aufgabe("verschicken")}   >{t("Datei versenden")}</Button>    
              </Grid>
              <Grid item xs={12} sm={6} >
                <Button  color="primary" variant="outlined" fullWidth   onClick={() => hdok_aufgabe("erledigen")}>{t("Aufgabe ohne hochladen erledigen")}</Button>         
              </Grid>
           </Grid>
           </Grid>
        </Grid>
        </Box>
       </ResponsiveDialog>
       <ResponsiveDialog 
          title={t("Detailansicht ") + auswahl.current.Bezeichnung}
          open={details}
          setOpen={(o) => {setDetails(false)}}
       >
       <Box p={1}> 
       <Grid container justifyContent="center">
          <Grid item xs={12}> 
          <Grid container justifyContent="center" spacing={2} >
            <Grid item xs={12}>
              <TextField  
                label={t("Bezeichnung")}
                fullWidth
                disabled
                value={auswahl.current.Bezeichnung}
                variant="outlined"                
              />
              </Grid>
            <Grid item xs={12}>
              <TextField  
                label={t("Inhaber")}
                fullWidth
                disabled
                value={auswahl.current.Inhaber}
                variant="outlined"                
              />
            </Grid>
            <Grid item xs={12}>
              <TextField  
                label={t("Erhalten am")}
                fullWidth
                disabled
                value={auswahl.current.Erhalten_am}
                variant="outlined"                
              />
            </Grid>
            <Grid item xs={12}>
              <TextField  
                label={t("Termin bis")}
                fullWidth
                disabled
                value={auswahl.current.Termin_bis}
                variant="outlined"                
              />
            </Grid>
            
            { auswahl.current.Erledigt_am &&
              <Grid item xs={12}>
                <TextField  
                  label={t("Erledigt am")}
                  fullWidth
                  disabled
                  value={auswahl.current.Erledigt_am}
                  variant="outlined"                
                />
              </Grid>
            } 
            { auswahl.current.Kategorie!=="Erledigt" &&
              <Fragment>
                <Grid item xs={12} sm={6}>
                  <Button  color="primary" variant="outlined" fullWidth   onClick={() => aktionen(auswahl.current,"bestätigen")}>{t("Erledigen")}</Button> 
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button  variant="outlined" fullWidth   onClick={() => aktionen(auswahl.current),"löschen"}>{t("Löschen")}</Button> 
                </Grid> 
              </Fragment>             
            } 
           </Grid>
           </Grid>
        </Grid>
        </Box>
       </ResponsiveDialog>
      </Layout>      
    </Page>
  )
}
export default ToDosGlobal;
